import { AnswerIconO, AnswerIconX } from '@/shared/components/AnswerIcon';
import { cn } from '@/utils/tailwind.util';
import { type BuildQuizListItem } from '@/views/build/form/schema/BuildQuizListSchema';
import { useEditMode } from '../../focus/useIsEditMode';
import { WithUnderline } from '../WithUnderline';
export const OXContent = ({
  answer,
  isVisible
}: {
  answer: BuildQuizListItem['oxData']['answer'];
  isVisible: boolean;
}) => {
  const {
    onEditModeChange
  } = useEditMode();
  return <div className={cn('group relative w-full cursor-pointer', 'hidden', isVisible && 'flex')} data-sentry-component="OXContent" data-sentry-source-file="OXContent.tsx">
      <WithUnderline className="flex w-full items-center justify-between pt-0 after:bottom-[-8px]" onMouseDown={e => {
      e.preventDefault();
    }} onClick={e => {
      e.stopPropagation();
      onEditModeChange(true);
    }} data-sentry-element="WithUnderline" data-sentry-source-file="OXContent.tsx">
        <div className="relative w-fit rounded-sm border border-alternative bg-white p-md">
          {answer === 'o' ? <AnswerIconO className="size-[40px]" /> : <AnswerIconX className="size-[40px]" />}
        </div>
      </WithUnderline>
    </div>;
};